import restClient from "../restClient";

export const getLogs = async (page = 1, pageSize = 10, userIds = [], type = null) => {
  try {
    const token = localStorage.getItem('token');
    const params = {
      "pagination[page]": page,
      "pagination[pageSize]": pageSize,
    };
    if (userIds?.length > 0) {
      params.userIds = userIds.join(",");
    }
    if (type) {
      params.type = type;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params,
    };
    const response = await restClient.get(`logs`, config);
    return response.data;
  } catch (err) {
    console.log(err);
    return null;
  }
};
